import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Lock } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Envía fotos, audios y notas por WhatsApp', 'Los audios se transcriben solos', 'Las observaciones se ordenan automáticamente', 'El informe se genera en formato profesional', 'Listo para descargar en minutos'];
  return <section id="solucion" className="py-16 sm:py-24 bg-white" data-id="element-406">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-407">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-16" data-id="element-408">
          <h2 className="text-sm font-semibold text-blue-600 tracking-wide uppercase mb-2" data-id="element-409">
            La solución
          </h2>
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-410">
            Tú visitas. InspectIA hace el informe.
          </h3>
        </div>

        <div className="lg:grid lg:grid-cols-12 lg:gap-12 items-center" data-id="element-411">
          {/* Bullets */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-5 mb-10 lg:mb-0" data-id="element-412">
            <ul className="space-y-4 sm:space-y-5" data-id="element-413">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-414">
                  <CheckCircle2 className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-415" />
                  <span className="ml-2.5 sm:ml-3 text-base sm:text-lg font-medium text-gray-800" data-id="element-416">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 sm:mt-10 flex items-start bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-417">
              <Lock className="h-5 w-5 sm:h-6 sm:w-6 text-gray-900 flex-shrink-0 mt-0.5 mr-2.5 sm:mr-3" data-id="element-418" />
              <p className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-419">
                Todo queda guardado. Siempre accesible.
              </p>
            </div>
          </motion.div>

          {/* Before / After Visual */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-7" data-id="element-420">
            <div className="bg-gray-50 rounded-2xl p-2 sm:p-4 border border-gray-200 flex flex-col sm:flex-row items-center gap-4" data-id="element-421">
              {/* Before */}
              <div className="flex-1 w-full bg-white rounded-xl border border-red-100 p-4 shadow-sm relative overflow-hidden" data-id="element-422">
                <div className="absolute top-0 left-0 w-full h-1 bg-red-400" data-id="element-423"></div>
                <div className="flex justify-between items-center mb-4" data-id="element-424">
                  <span className="text-xs font-bold text-red-500 uppercase tracking-wider bg-red-50 px-2 py-1 rounded" data-id="element-425">
                    Antes
                  </span>
                </div>
                <div className="relative h-48 bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-426">
                  {/* Dot grid background */}
                  <div className="absolute inset-0 opacity-30" style={{
                  backgroundImage: 'radial-gradient(#e5e7eb 1px, transparent 1px)',
                  backgroundSize: '12px 12px'
                }} data-id="element-427" />

                  {/* Mini arrows SVG */}
                  <svg className="absolute inset-0 w-full h-full pointer-events-none z-0" data-id="element-428">
                    <defs data-id="element-429">
                      <marker id="mini-arrow" markerWidth="4" markerHeight="3" refX="3" refY="1.5" orient="auto" data-id="element-430">
                        <polygon points="0 0, 4 1.5, 0 3" fill="#d1d5db" data-id="element-431" />
                      </marker>
                      <marker id="mini-arrow-red" markerWidth="4" markerHeight="3" refX="3" refY="1.5" orient="auto" data-id="element-432">
                        <polygon points="0 0, 4 1.5, 0 3" fill="#fca5a5" data-id="element-433" />
                      </marker>
                    </defs>
                    <path d="M 30 35 Q 55 55 70 70" stroke="#d1d5db" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#mini-arrow)" data-id="element-434" />
                    <path d="M 155 35 Q 130 55 115 70" stroke="#d1d5db" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#mini-arrow)" data-id="element-435" />
                    <path d="M 30 155 Q 55 135 70 120" stroke="#d1d5db" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#mini-arrow)" data-id="element-436" />
                    <path d="M 155 155 Q 130 135 115 120" stroke="#d1d5db" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#mini-arrow)" data-id="element-437" />
                    <path d="M 90 25 Q 85 50 88 65" stroke="#fca5a5" strokeWidth="0.8" fill="none" strokeDasharray="2 2" markerEnd="url(#mini-arrow-red)" data-id="element-438" />
                    <path d="M 170 90 Q 140 92 120 93" stroke="#d1d5db" strokeWidth="0.8" fill="none" strokeDasharray="2 3" markerEnd="url(#mini-arrow)" data-id="element-439" />
                    <path d="M 165 50 Q 150 70 155 90" stroke="#e5e7eb" strokeWidth="0.8" fill="none" strokeDasharray="2 3" data-id="element-440" />
                    <path d="M 170 130 Q 150 120 140 110" stroke="#e5e7eb" strokeWidth="0.8" fill="none" strokeDasharray="2 3" data-id="element-441" />
                  </svg>

                  {/* Mini Photos card (top-left) */}
                  <div className="absolute top-2 left-2 w-16 bg-white rounded border border-gray-200 shadow-sm p-1 z-10 -rotate-3" data-id="element-442">
                    <div className="flex items-center gap-0.5 mb-1" data-id="element-443">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400" data-id="element-444" />
                      <span className="text-[5px] font-semibold text-gray-600" data-id="element-445">
                        47 fotos
                      </span>
                    </div>
                    <div className="grid grid-cols-3 gap-px" data-id="element-446">
                      <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-447">
                        <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=50&h=50&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-448" />
                      </div>
                      <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-449">
                        <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=50&h=50&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-450" />
                      </div>
                      <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-451">
                        <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=50&h=50&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-452" />
                      </div>
                      <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-453">
                        <img src="https://images.unsplash.com/photo-1429497419816-9ca5cfb4571a?w=50&h=50&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-454" />
                      </div>
                      <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-455">
                        <img src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=50&h=50&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-456" />
                      </div>
                      <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-457">
                        <img src="https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=50&h=50&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-458" />
                      </div>
                    </div>
                    <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full border border-white" data-id="element-459" />
                  </div>

                  {/* Mini Audio card (top-right) */}
                  <div className="absolute top-3 right-3 w-14 bg-white rounded border border-gray-200 shadow-sm p-1 z-10 rotate-2" data-id="element-460">
                    <div className="flex items-center gap-0.5 mb-1" data-id="element-461">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400" data-id="element-462" />
                      <span className="text-[5px] font-semibold text-gray-600" data-id="element-463">
                        12 audios
                      </span>
                    </div>
                    <div className="bg-green-50 rounded-full px-1 py-0.5 flex items-center gap-0.5 border border-green-100 mb-0.5" data-id="element-464">
                      <div className="w-1 h-1 bg-green-500 rounded-full" data-id="element-465" />
                      <div className="flex items-center gap-px h-1.5" data-id="element-466">
                        <div className="w-px h-0.5 bg-green-400 rounded-full" data-id="element-467" />
                        <div className="w-px h-1 bg-green-400 rounded-full" data-id="element-468" />
                        <div className="w-px h-1.5 bg-green-400 rounded-full" data-id="element-469" />
                        <div className="w-px h-0.5 bg-green-400 rounded-full" data-id="element-470" />
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-full px-1 py-0.5 flex items-center gap-0.5 border border-gray-100" data-id="element-471">
                      <div className="w-1 h-1 bg-gray-400 rounded-full" data-id="element-472" />
                      <div className="flex items-center gap-px h-1.5" data-id="element-473">
                        <div className="w-px h-1 bg-gray-300 rounded-full" data-id="element-474" />
                        <div className="w-px h-0.5 bg-gray-300 rounded-full" data-id="element-475" />
                        <div className="w-px h-1 bg-gray-300 rounded-full" data-id="element-476" />
                      </div>
                    </div>
                    <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full border border-white" data-id="element-477" />
                  </div>

                  {/* Center — Missing destination */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 border-[1.5px] border-dashed border-red-300 rounded-lg bg-red-50/50 flex flex-col items-center justify-center z-10" data-id="element-478">
                    <span className="text-red-300 text-sm font-bold leading-none" data-id="element-479">
                      ?
                    </span>
                    <span className="text-[4px] text-red-400 font-medium mt-0.5" data-id="element-480">
                      ¿Dónde va todo?
                    </span>
                  </div>

                  {/* Mini Notes card (bottom-left) */}
                  <div className="absolute bottom-3 left-3 w-14 bg-white rounded border border-gray-200 shadow-sm p-1 z-10 rotate-2" data-id="element-481">
                    <div className="flex items-center gap-0.5 mb-1" data-id="element-482">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400" data-id="element-483" />
                      <span className="text-[5px] font-semibold text-gray-600" data-id="element-484">
                        Notas
                      </span>
                    </div>
                    <div className="space-y-0.5" data-id="element-485">
                      <div className="h-0.5 w-full bg-gray-200 rounded-full" data-id="element-486" />
                      <div className="h-0.5 w-3/4 bg-amber-200 rounded-full" data-id="element-487" />
                      <div className="h-0.5 w-5/6 bg-gray-200 rounded-full" data-id="element-488" />
                    </div>
                  </div>

                  {/* Mini Messages card (bottom-right) */}
                  <div className="absolute bottom-2 right-2 w-14 bg-white rounded border border-gray-200 shadow-sm p-1 z-10 -rotate-2" data-id="element-489">
                    <div className="flex items-center gap-0.5 mb-1" data-id="element-490">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400" data-id="element-491" />
                      <span className="text-[5px] font-semibold text-gray-600" data-id="element-492">
                        Mensajes
                      </span>
                    </div>
                    <div className="space-y-0.5" data-id="element-493">
                      <div className="bg-gray-100 rounded rounded-tl-none p-0.5 w-4/5" data-id="element-494">
                        <div className="h-px w-full bg-gray-300 rounded-full" data-id="element-495" />
                      </div>
                      <div className="bg-green-50 rounded rounded-tr-none p-0.5 w-4/5 ml-auto border border-green-100" data-id="element-496">
                        <div className="h-px w-full bg-green-300 rounded-full" data-id="element-497" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Arrow */}
              <div className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full bg-white border border-gray-200 shadow-sm z-10 shrink-0" data-id="element-498">
                <ArrowRight className="w-5 h-5 text-gray-400" data-id="element-499" />
              </div>
              <div className="sm:hidden flex items-center justify-center w-10 h-10 rounded-full bg-white border border-gray-200 shadow-sm z-10 shrink-0 rotate-90 my-[-1rem]" data-id="element-500">
                <ArrowRight className="w-5 h-5 text-gray-400" data-id="element-501" />
              </div>

              {/* After */}
              <div className="flex-1 w-full bg-white rounded-xl border border-blue-100 p-4 shadow-sm relative overflow-hidden" data-id="element-502">
                <div className="absolute top-0 left-0 w-full h-1 bg-blue-500" data-id="element-503"></div>
                <div className="flex justify-between items-center mb-3" data-id="element-504">
                  <span className="text-xs font-bold text-blue-600 uppercase tracking-wider bg-blue-50 px-2 py-1 rounded" data-id="element-505">
                    Después
                  </span>
                  <span className="text-[9px] text-gray-400 font-medium" data-id="element-506">
                    PDF Generado
                  </span>
                </div>
                <div className="relative h-48 bg-blue-50/20 rounded-lg border border-blue-100/50 p-3 overflow-hidden" data-id="element-507">
                  {/* Clean Report Layout */}
                  <div className="border-b border-gray-200 pb-1.5 mb-2" data-id="element-508">
                    <div className="h-2 w-1/3 bg-gray-800 rounded mb-1" data-id="element-509"></div>
                    <div className="h-1.5 w-1/4 bg-gray-400 rounded" data-id="element-510"></div>
                  </div>

                  <div className="flex gap-2 mb-3" data-id="element-511">
                    <div className="w-1/3" data-id="element-512">
                      <div className="aspect-square bg-gray-100 rounded overflow-hidden" data-id="element-513">
                        <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=150&h=150&fit=crop" className="w-full h-full object-cover" data-id="element-514" />
                      </div>
                    </div>
                    <div className="w-2/3 space-y-1" data-id="element-515">
                      <div className="h-1.5 w-1/2 bg-blue-600 rounded" data-id="element-516"></div>
                      <div className="h-1 w-full bg-gray-300 rounded" data-id="element-517"></div>
                      <div className="h-1 w-full bg-gray-300 rounded" data-id="element-518"></div>
                      <div className="h-1 w-4/5 bg-gray-300 rounded" data-id="element-519"></div>
                    </div>
                  </div>

                  <div className="flex gap-2" data-id="element-520">
                    <div className="w-1/3" data-id="element-521">
                      <div className="aspect-square bg-gray-100 rounded overflow-hidden" data-id="element-522">
                        <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=150&h=150&fit=crop" className="w-full h-full object-cover" data-id="element-523" />
                      </div>
                    </div>
                    <div className="w-2/3 space-y-1" data-id="element-524">
                      <div className="h-1.5 w-1/2 bg-blue-600 rounded" data-id="element-525"></div>
                      <div className="h-1 w-full bg-gray-300 rounded" data-id="element-526"></div>
                      <div className="h-1 w-5/6 bg-gray-300 rounded" data-id="element-527"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}